import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    FormControlLabel,
    FormControl,
    Checkbox,
    Input,
    IconButton,
    Icon
} from 'components';
import styles from './CheckBoxBuilderOption.scss';

class CheckBoxBuilderOption extends Component {
    render () {
        const {
            item,
            dragHandleProps,
            commonProps
        } = this.props;

        const {
            onChangeItemText,
            onRemoveItem,
            isDisabled,
            newItemPlaceholder
        } = commonProps;

        return (
            <FormControlLabel
                disabled
                className={styles.checkboxContainer}
                control={ <Checkbox checked={item.checked} /> }
                label={
                    <FormControl>
                        <Input
                            autoFocus
                            value={item.item}
                            onChange={e => onChangeItemText(e, item.index)}
                            placeholder={newItemPlaceholder}
                            inputProps={{'aria-label': item.item || newItemPlaceholder}}
                            disabled={isDisabled}
                            disableUnderline
                            fullWidth
                            className={styles.input}
                            endAdornment={
                                <div className={styles.iconsContainer}>
                                    <IconButton
                                        disabled={isDisabled}
                                        className={styles.trashIcon}
                                        color='secondary'
                                        onClick={() => onRemoveItem(item.index)}
                                    >
                                        <Icon name='ion-md-trash' />
                                    </IconButton>
                                    <IconButton
                                        disabled={isDisabled}
                                        className={styles.dragHandle}
                                        {...dragHandleProps}
                                    >
                                        <Icon name='ion-md-menu' />
                                    </IconButton>
                                </div>
                            }
                        />
                    </FormControl>
                }
            />
        );
    }
}

CheckBoxBuilderOption.propTypes = {
    item: PropTypes.shape({
        index: PropTypes.string,
        item: PropTypes.string,
        checked: PropTypes.bool
    }),
    dragHandleProps: PropTypes.object,
    commonProps: PropTypes.shape({
        onChangeItemText: PropTypes.func,
        onRemoveItem: PropTypes.func,
        isDisabled: PropTypes.bool,
        newItemPlaceholder: PropTypes.string
    })
};

export default CheckBoxBuilderOption;
